namespace GeniuzPOS.CustomReport {
    export interface ReportCustomerSurveyTranDtForm {
        ChoiceId: Serenity.IntegerEditor;
        Choice: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        PosId: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        MbId: Serenity.StringEditor;
        CreateBy: Serenity.StringEditor;
    }

    export class ReportCustomerSurveyTranDtForm extends Serenity.PrefixedContext {
        static formKey = 'CustomReport.ReportCustomerSurveyTranDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportCustomerSurveyTranDtForm.init)  {
                ReportCustomerSurveyTranDtForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(ReportCustomerSurveyTranDtForm, [
                    'ChoiceId', w0,
                    'Choice', w1,
                    'DocNo', w1,
                    'PosId', w1,
                    'ShopId', w1,
                    'MbId', w1,
                    'CreateBy', w1
                ]);
            }
        }
    }
}
